import {
  ApplicationDependency,
  ITApplication,
} from '../enterprise-applications';

type TreeNode = {
  uuid: string;
  name: string;
  children?: TreeNode[];
  applications?: ApplicationDependency[] & ITApplication[];
};

const LAST_ITEM_LABEL = 'All Other';

export const pushAllOtherToBottom = (items: any[]): TreeNode[] => {
  return items
    .map((item) => {
      const children = item.children
        ? pushAllOtherToBottom(item.children)
        : undefined;

      return {
        ...item,
        ...(children ? { children } : {}),
      };
    })
    .filter((item) => !item.name.startsWith(LAST_ITEM_LABEL))
    .concat(items.filter((item) => item.name.startsWith(LAST_ITEM_LABEL)));
};

export const formatTree = (node: any): TreeNode[] => {
  return node?.map((item: any) => {
    const { productGroups, applications, ...rest } = item;
    return {
      ...rest,
      applications: applications.map((itApp: any) => {
        const { description, ...rest } = itApp;
        return {
          ...rest,
          comment: itApp?.description,
        };
      }),
      children: productGroups?.map((item: any) => {
        const { products, ...rest } = item;
        return {
          ...rest,
          children: products,
        };
      }),
    };
  });
};
